import React from "react";
import { Box } from "@mui/material";

import ActivityTable from "../../PORT/Activity/ActivityTable";
import FormBuilder from "../../../Common/FormBuilder/FormBuilder";

function ActivityContent({ segment, onFormFieldChange, appraisalId, appCode }) {
    const canUpdate = segment?.canUpdate ?? false;
    return (
        <>
            <Box className="card-content">
                <ActivityTable
                    canUpdate={canUpdate}
                    items={segment?.items ?? []}
                    appraisalId={appraisalId}
                    inputSegmentId={segment?.index}
                    appCode={appCode}
                />
            </Box>
            <FormBuilder
                form={segment?.form ?? []}
                canUpdate={canUpdate}
                onFieldChange={onFormFieldChange}
            />
        </>
    );
}

export default ActivityContent;
